<div class="feature">
  <div class="top">
    <div class="feature_title">{{ featureInfo.featureTitle | translate }}</div>
    <div class="description">{{ featureInfo.description | translate }}</div>
    <ul class="top-points">
      <li *ngFor="let point of featureInfo.topPoints">{{ point | translate }}</li>
    </ul>
    <a mat-raised-button color="primary" [routerLink]="['/upgrade-subscription-tier']">
      {{ 'RESTRICTED_FEATURE_CONTENT_V2.UPGRADE' | translate }}
    </a>
    <a mat-raised-button color="secondary" [routerLink]="featureInfo.learnMoreLink">
      {{ 'RESTRICTED_FEATURE_CONTENT_V2.LEARN_MORE' | translate }}
    </a>
    <img class="feature-image" src="{{ featuredImage }}" />
  </div>
  <div class="more-info">
    <div class="more-info-title">{{ featureInfo.moreInfoTitle | translate }}</div>
    <mat-card appearance="outlined">
      <mat-card-content>
        <mat-icon>{{ featureInfo.moreInfoSection1Icon }}</mat-icon>
        {{ featureInfo.moreInfoSection1Title | translate }}
        {{ featureInfo.moreInfoSection1Description | translate }}
        <a mat-raised-button color="secondary" [routerLink]="featureInfo.moreInfoSection1Link">
          {{ 'RESTRICTED_FEATURE_CONTENT_V2.LEARN_MORE' | translate }}
        </a>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-content>
        <mat-icon>{{ featureInfo.moreInfoSection2Icon }}</mat-icon>
        {{ featureInfo.moreInfoSection2Title | translate }}
        {{ featureInfo.moreInfoSection2Description | translate }}
        <a mat-raised-button color="secondary" [routerLink]="featureInfo.moreInfoSection2Link">
          {{ 'RESTRICTED_FEATURE_CONTENT_V2.LEARN_MORE' | translate }}
        </a>
      </mat-card-content>
    </mat-card>
  </div>
  <div *ngIf="featureInfo.videoLink" class="video"></div>
  <div *ngIf="featureInfo.faqs" class="faq">
    <mat-accordion>
      <mat-expansion-panel *ngFor="let faq of featureInfo.faqs">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ faq.question | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p>{{ faq.answer | translate }}</p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
